import { useEffect, useRef, useState } from "react";
import { Box, Grid, Typography, Button, Stack } from "@mui/material";

const TailoredRingSection = () => {
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const node = sectionRef.current;
        if (!node) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.3 }
        );

        observer.observe(node);
        return () => observer.disconnect();
    }, []);

    return (
        <Box
            ref={sectionRef}
            className={`clearbox-hero tailoredring-hero ${isVisible ? "is-visible" : ""}`}
            sx={{
                position: "relative",
                backgroundImage:
                    "url(" +
                    process.env.PUBLIC_URL +
                    "/static/images/hero/white_wall.jpg)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundAttachment: "scroll",
            }}
        >
            <Box
                sx={{
                    maxWidth: "1400px",
                    margin: "0 auto",
                    padding: { xs: "80px 24px 60px", md: "100px 40px 80px" },
                }}
                className="clearbox-hero-inner"
            >
                <Grid
                    container
                    spacing={6}
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
                        <Box
                            className="clearbox-hero-text"
                            sx={{
                                textAlign: { xs: "center", md: "left" },
                                color: "var(--secondary-color)",
                            }}
                        >
                            {/* Title */}
                            <Typography
                                variant="h3"
                                sx={{
                                    fontWeight: 800,
                                    fontSize: { xs: "2rem", sm: "2.4rem", md: "2.8rem" },
                                    mb: 3,
                                    letterSpacing: "-0.04em",
                                }}
                            >
                                Tailored Rings
                            </Typography>

                            {/* Description */}
                            <Typography
                                variant="body1"
                                sx={{
                                    fontSize: { xs: "1rem", md: "1.1rem" },
                                    maxWidth: { xs: "100%", md: "480px" },
                                    mx: { xs: "auto", md: 0 },
                                    mb: 4,
                                    lineHeight: 1.7,
                                    opacity: 0.95,
                                }}
                            >
                                Premium custom jewelry combining 3D printing mastery with artisan
                                craftsmanship. Each ring is hand-finished, rigorously tested, and
                                guaranteed for lifetime quality. Expert process control ensures
                                perfect fit and durability, with custom design quotes available
                                upon request.
                            </Typography>

                            {/* Actions */}
                            <Stack
                                direction={{ xs: "column", sm: "row" }}
                                spacing={2.5}
                                sx={{
                                    justifyContent: { xs: "center", md: "flex-start" },
                                    alignItems: { xs: "stretch", sm: "center" },
                                }}
                            >
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    href="https://tailoredrings.com/"
                                    target="_blank"
                                    rel="noreferrer"
                                    sx={{
                                        px: 4,
                                        py: 1.2,
                                        borderRadius: "999px",
                                        backgroundColor: "var(--primary-color)",
                                        fontWeight: 700,
                                        textTransform: "none",
                                        boxShadow:
                                            "0 10px 30px rgba(108, 152, 173, 0.6), 0 0 0 1px rgba(255,255,255,0.15)",
                                    }}
                                >
                                    Learn more
                                </Button>
                            </Stack>
                        </Box>
                    </Grid>

                    {/* Right: Tailored Rings image */}
                    <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
                        <Box
                            className="clearbox-hero-image"
                            sx={{
                                display: "flex",
                                justifyContent: { xs: "center", md: "flex-end" },
                            }}
                        >
                            <Box
                                sx={{
                                    width: { xs: 320, sm: 420, md: 560 },
                                    height: { xs: 320, sm: 420, md: 560 },
                                    borderRadius: "32px",
                                    border: "1px solid rgba(255,255,255,0.4)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    overflow: "hidden",
                                    position: "relative",
                                }}
                            >
                                <img
                                    src={
                                        process.env.PUBLIC_URL +
                                        "/static/images/tailoredRings.jpg"
                                    }
                                    alt="Tailored Rings"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                />
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default TailoredRingSection;
